module.exports = __webpack_public_path__ + "img/image_4.1e154936.png";